<script setup>
import PlanCard from "./PlanCard.vue";
import PlansModalBase from "./PlansModalBase.vue";

import axios from "axios";
import { defineProps, onMounted, ref, defineEmits } from "vue";
import { useI18n } from "vue-i18n";
import { useToast } from "vue-toastification";

const { tm } = useI18n();

const { open, plans, updateSubscriptionData, userData } = defineProps([
  "open",
  "plans",
  "updateSubscriptionData",
  "userData",
]);
const emit = defineEmits(["close"]);

const isOpen = computed({
  get: () => open,
  set: (value) => {
    emit("close");
  },
});

const plansBenefits = computed(() => tm("billing.plans_benefits1"));
</script>
<template>
  <PlansModalBase :open="open" @close="emit('close')">
    <PlanCard
      v-for="(plan, index) in plans"
      :plan="plan"
      :plansBenefits="plansBenefits[index]"
      :userData="userData"
      @closeModal="isOpen = false"
    />
  </PlansModalBase>
</template>
